import { LDClient, useLDClient } from 'launchdarkly-react-client-sdk';

import { isDev } from '~/dev/utils/isDev';

import { flags, FlagType } from './flags';
import { useFlags } from './useFlags';

let ldClient: LDClient | undefined;

export const useFlag = <F extends FlagType>(featureFlag: F) =>
  useFlags()[featureFlag] as (typeof flags)[F];

export const useExposeLDClient = () => {
  ldClient = useLDClient();
};

export const getFlag = <F extends FlagType>(featureFlag: F) =>
  Boolean(isDev ? flags[featureFlag] : ldClient?.variation(featureFlag, false));
